import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { StringRequest } from "../../services/StringRequest";
import { SysAdminService } from "../../services/sysadmin.service";
import { AppItemInfo } from "../role-admin-add-role/AppItemInfo";
import { CreateRoleRequestModel } from "../role-admin-add-role/CreateRoleRequestModel";
import { ManageApplicationItemsComponent } from "../role-admin-add-role/manage-application-items/manage-application-items.component";
import { ManageReportsComponent } from "../role-admin-add-role/manage-reports/manage-reports.component";

@Component({
	selector: "app-role-admin-copy-role",
	templateUrl: "./role-admin-copy-role.component.html",
	styleUrls: ["./role-admin-copy-role.component.css"],
})
export class RoleAdminCopyRoleComponent implements OnInit {
	constructor(
		private userService: UserService,
		private sysAdminService: SysAdminService,
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//Get data from parent
		this.RoleID = this.dialogConfig.data.RoleID;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//Get data from DB
		this.loadRoleData();
		// this.loadUserLevels();
	}

	//////////////////////////////////////////
	// Data
	//////////////////////////////////////////
	user: any;

	//Get data from children
	@ViewChild(ManageApplicationItemsComponent)
	appItemComp: ManageApplicationItemsComponent;

	@ViewChild(ManageReportsComponent)
	reportItemComp: ManageReportsComponent;

	//Data From Parent
	RoleID: any = "";
	SchoolID: any = 0;

	//Form Data
	RoleName: any = "";
	RoleDesc: any = "";
	SelectedUserLevel: any;
	AllSchools: any = false;

	lstUserLevels: any = [];

	AppItemData: any = null;
	ReportData: any = null;

	errorMessage: any = "";

	RoleData: any;
	ReportsFromMain: any;
	AppItemsFromMain: any;

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////

	loadRoleData() {
		var result = this.sysAdminService.RoleSelect(this.RoleID);
		result.subscribe(
			(response) => {
				this.RoleData = response[0];

				//Update Data
				this.UpdateData();
			},
			(error) => {}
		);
	}

	UpdateData() {
		this.RoleName = this.RoleData.RoleName;
		this.RoleDesc = this.RoleData.RoleDesc;

		if (this.RoleData.SchoolName == "District" || this.RoleData.SchoolID <= 0) {
			this.AllSchools = true;
		}

		//Reports
		this.UpdateReports();

		//Application Items
		this.UpdateApplicationItems();

		this.loadUserLevels();
	}

	UpdateApplicationItems() {
		// for(var i = 0; i < this.RoleData.applicationItems.length; i++){
		//   var nextApp = this.RoleData.applicationItems[i];

		//   if(nextApp.Children != undefined){
		//     for(var x = 0; x < nextApp.Children.length; x++){
		//       var nextChild = nextApp.Children[x];

		//     }
		//   }

		// }

		this.AppItemsFromMain = this.RoleData.applicationItems;
	}

	UpdateReports() {
		//Fixing group names
		for (var i = 0; i < this.RoleData.reports.length; i++) {
			var next = this.RoleData.reports[i];

			next.ReportDisplayName = next.ReportDisplayName.replace("/", " ").replace(" w ", " With");

			if (next.ReportGroupDesc == "District") {
				next.ReportGroupDesc = "Action";
			}

			if (next.ReportDisplayName == "Attendance by") {
				next.ReportDisplayName = "Attendance By Type";
			}
			if (String(next.ReportDisplayName) == "Student Absent Tardy Excuses") {
				next.ReportDisplayName = "Student Absent Tardy Excuse";
			}
		}

		this.ReportsFromMain = this.RoleData.reports;

		// for(var i = 0; i < this.RoleData.reports.length; i++){
		//   var nextReport = this.RoleData.reports[i];

		//   for(var x = 0; x < this.reportItemComp.TreeItems.length; x++){
		//     var nextItem =this.reportItemComp.TreeItems[x];

		//     if(nextReport.ReportDisplayName == nextItem.data.ApplicationItemName){
		//       nextItem.data.Access = true;
		//       break;
		//     }

		//   }

		//}
	}

	loadUserLevels() {
		var result = this.sysAdminService.UserLevelGetList();
		result.subscribe(
			(response) => {
				this.lstUserLevels = response;
				this.SelectedUserLevel = this.lstUserLevels[0].UserLevelID;

				if (this.RoleData.UserLevelID != undefined) {
					this.SelectedUserLevel = this.RoleData.UserLevelID;
				}
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////

	onUpdate() {
		this.errorMessage = "";

		//Error Handling
		if (this.RoleName == "") {
			this.errorMessage = "Enter a Role Name";
			return;
		}
		if (this.RoleDesc == "") {
			this.errorMessage = "Enter a Role Description";
			return;
		}

		//Check if name is used
		//Check if desc is used
		this.CheckName();
	}

	CheckName() {
		let parms: StringRequest = {
			str: this.RoleName,
		};

		var result = this.sysAdminService.RoleNameUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Role Name already in use";
					return;
				} else {
					//Check if desc is used
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.RoleDesc,
		};

		var result = this.sysAdminService.RoleDescUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Role Description already in use";
					return;
				} else {
					//Check if desc is used
					this.CreateRole();
				}
			},
			(error) => {}
		);
	}

	CreateRole() {
		//Get data from children
		this.AppItemData = this.appItemComp.TreeItems;
		this.ReportData = this.reportItemComp.TreeItems;

		//Create request data
		var FormattedAppItems: AppItemInfo[] = [];
		var FormattedReportItems: AppItemInfo[] = [];

		//App Items
		for (var i = 0; i < this.AppItemData.length; i++) {
			var next = this.AppItemData[i];

			var nextAppItem: AppItemInfo = {
				ApplicationItemID: next.data.ApplicationItemID,
				ApplicationItemKey: next.data.ApplicationItemKey,
				ApplicationItemName: next.data.ApplicationItemName,
				Access: next.data.Access == true ? 1 : 0,
				AccessRead: next.data.AccessRead == true ? 1 : 0,
				AccessUpdate: next.data.AccessUpdate == true ? 1 : 0,
				AccessInsert: next.data.AccessInsert == true ? 1 : 0,
				AccessDelete: next.data.AccessDelete == true ? 1 : 0,
				ReportID: -1,
			};

			FormattedAppItems = [...FormattedAppItems, nextAppItem];

			if (next.children != undefined) {
				for (var x = 0; x < next.children.length; x++) {
					var child = next.children[x];

					var nextAppItem: AppItemInfo = {
						ApplicationItemID: child.data.ApplicationItemID,
						ApplicationItemKey: child.data.ApplicationItemKey,
						ApplicationItemName: child.data.ApplicationItemName,
						Access: child.data.Access == true ? 1 : 0,
						AccessRead: child.data.AccessRead == true ? 1 : 0,
						AccessUpdate: child.data.AccessUpdate == true ? 1 : 0,
						AccessInsert: child.data.AccessInsert == true ? 1 : 0,
						AccessDelete: child.data.AccessDelete == true ? 1 : 0,
						ReportID: -1,
					};

					FormattedAppItems = [...FormattedAppItems, nextAppItem];

					if (child.children != undefined) {
						for (var z = 0; z < child.children.length; z++) {
							var subChild = child.children[z];

							var nextAppItem: AppItemInfo = {
								ApplicationItemID: subChild.data.ApplicationItemID,
								ApplicationItemKey: subChild.data.ApplicationItemKey,
								ApplicationItemName: subChild.data.ApplicationItemName,
								Access: subChild.data.Access == true ? 1 : 0,
								AccessRead: subChild.data.AccessRead == true ? 1 : 0,
								AccessUpdate: subChild.data.AccessUpdate == true ? 1 : 0,
								AccessInsert: subChild.data.AccessInsert == true ? 1 : 0,
								AccessDelete: subChild.data.AccessDelete == true ? 1 : 0,
								ReportID: -1,
							};

							FormattedAppItems = [...FormattedAppItems, nextAppItem];
						}
					}
				}
			}
		}

		//Report Items
		for (var i = 0; i < this.ReportData.length; i++) {
			var next = this.ReportData[i];

			var nextAppItem: AppItemInfo = {
				ApplicationItemID: next.data.ApplicationItemID,
				ApplicationItemKey: next.data.ApplicationItemKey,
				ApplicationItemName: next.data.ApplicationItemName,
				Access: next.data.Access == true ? 1 : 0,
				AccessRead: next.data.AccessRead == true ? 1 : 0,
				AccessUpdate: next.data.AccessUpdate == true ? 1 : 0,
				AccessInsert: next.data.AccessInsert == true ? 1 : 0,
				AccessDelete: next.data.AccessDelete == true ? 1 : 0,
				ReportID: next.data.ReportID,
			};

			FormattedReportItems = [...FormattedReportItems, nextAppItem];

			if (next.children != undefined) {
				for (var x = 0; x < next.children.length; x++) {
					var child = next.children[x];

					var nextAppItem: AppItemInfo = {
						ApplicationItemID: child.data.ApplicationItemID,
						ApplicationItemKey: child.data.ApplicationItemKey,
						ApplicationItemName: child.data.ApplicationItemName,
						Access: child.data.Access == true ? 1 : 0,
						AccessRead: child.data.AccessRead == true ? 1 : 0,
						AccessUpdate: child.data.AccessUpdate == true ? 1 : 0,
						AccessInsert: child.data.AccessInsert == true ? 1 : 0,
						AccessDelete: child.data.AccessDelete == true ? 1 : 0,
						ReportID: child.data.ReportID,
					};

					FormattedReportItems = [...FormattedReportItems, nextAppItem];

					if (child.children != undefined) {
						for (var z = 0; z < child.children.length; z++) {
							var subChild = child.children[z];

							var nextAppItem: AppItemInfo = {
								ApplicationItemID: subChild.data.ApplicationItemID,
								ApplicationItemKey: subChild.data.ApplicationItemKey,
								ApplicationItemName: subChild.data.ApplicationItemName,
								Access: subChild.data.Access == true ? 1 : 0,
								AccessRead: subChild.data.AccessRead == true ? 1 : 0,
								AccessUpdate: subChild.data.AccessUpdate == true ? 1 : 0,
								AccessInsert: subChild.data.AccessInsert == true ? 1 : 0,
								AccessDelete: subChild.data.AccessDelete == true ? 1 : 0,
								ReportID: subChild.data.ReportID,
							};

							FormattedReportItems = [...FormattedReportItems, nextAppItem];
						}
					}
				}
			}
		}

		var parms: CreateRoleRequestModel = {
			RoleName: this.RoleName,
			RoleDesc: this.RoleDesc,
			UserLevelID: this.SelectedUserLevel,
			SchoolID: this.SchoolID,
			AllSchools: this.AllSchools == true ? 1 : 0,
			ApplicationItems: FormattedAppItems,
			Reports: FormattedReportItems,
			DefinedByID: this.user.UserLevelID == 1 ? 4 : 3,
		};

		//Call SP
		var result = this.sysAdminService.CreateRole(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "CopyRole",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Role was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "CopyRole",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the Role",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Events
	//////////////////////////////////////////

	//////////////////////////////////////////
}
